/**
 * @module framework/directives/focus
 */

import { VueReCaptcha } from 'vue-recaptcha-v3';

import { App } from '~/framework/vue';

const recaptchaOptions = {
    // @ts-expect-error recaptcha key is a custom property
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    siteKey: window.recaptchaKey ?? '',
    useReCaptchaNet: true,
    useEnterprise: true
}

// 
export const recaptchaV3 = (app: App<HTMLElement>) => {
    app.use(VueReCaptcha, recaptchaOptions);
};
